import React, {useState} from 'react';
import TableHeader from '../TableContainer/TableHeader';
import CheckBox from '../CheckBox';
import {useLanguageContext, useThemeContext} from '../../../context';
import {QtyIncreaseDecrase} from '../V2';

const List = ({item, handleUpdateItemQty, selectedItems, handleChecked, order_lines}) => {
    const {I18n} = useLanguageContext();
    const {theme} = useThemeContext();
    const getInitialQuantity = order_lines.find(ol => ol.id === item?.id)?.quantity;
    console.log(item?.name, getInitialQuantity);

    return (
        <div className="width100">
            <TableHeader className={`fiveColumn`} style={{borderColor: theme.posRightBg}}>
                <div className="BoxWidth fontWeight400 justifyStart refundScreenCheckbox">
                    <CheckBox
                        checkboxLabel={
                            <p className="marBot0 fontSize16" style={{color: theme.text}}>
                                {item?.name}
                            </p>
                        }
                        onChange={() => handleChecked(item)}
                        checked={selectedItems[item?.id]}
                    />
                </div>
                <div className="BoxWidth fontWeight400 justifyCenter">
                    <QtyIncreaseDecrase item={item} toggle={true} handleUpdateItemQty={handleUpdateItemQty} initialQuantity={getInitialQuantity} />
                </div>
                <div className="BoxWidth fontWeight400 justifyCenter">
                    <p className="fontSize16 OneLineTruncate" style={{color: theme.white}}>
                        Rs. {item.discount || 0}
                    </p>
                </div>
                <div className="BoxWidth fontWeight400 justifyCenter">
                    <p className="fontSize16 OneLineTruncate" style={{color: theme.white}}>
                        Rs. {item?.selling_price}
                    </p>
                </div>
                <div className="BoxWidth fontWeight400 justifyCenter">
                    <p className="fontSize16 OneLineTruncate" style={{color: theme.white}}>
                        Rs. {item?.selling_price * item?.quantity}
                    </p>
                </div>
            </TableHeader>
        </div>
    );
};

export default List;
